import React, { FC, ReactText, useEffect, useState } from "react";
import { Aligment, Dropdown, Input, Modal, Text } from "venice-ui";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary";
import { useStoreState } from "../../store";
import { IntputWrapperBig } from "../SingIn/Login.styles";
import { getMemberEmail } from "../../helpers/organizationHelper";
import { IOption } from "../../definitions/element";
import { MEMBER_ROLE } from "../../definitions/organizations";

interface IDeleteProjectModalProps {
  handleCancel: () => void;
  handleDelete: (newEmail?: string) => void;
  loader: boolean;
  userID: string;
  isOpen: boolean;
}

export const DeleteUserModal: FC<IDeleteProjectModalProps> = ({
  handleCancel,
  handleDelete,
  loader,
  userID,
  isOpen,
}) => {
  const { email, uid } = useStoreState((state) => state.user.userDetails);
  const { members, email: orgMail } = useStoreState(
    (state) => state.organization
  );

  const isSelf = uid === userID;
  const [needChange, setNeedChange] = useState(false);
  const [emailToCheck, setEmailToCheck] = useState("");

  useEffect(() => {
    setEmailToCheck(isSelf ? email : getMemberEmail(members, userID));
    const member = members.find(
      (_memeber) =>
        _memeber.id === userID && _memeber.role === MEMBER_ROLE.admin
    );
    if (orgMail === member?.email) {
      setNeedChange(true);
    }
  }, []);

  const [pageData, setPageData] = useState({
    email: "",
    newEmail: "",
  });

  const setEmailValue = (field: string, value: string) => {
    setPageData({
      ...pageData,
      [field]: value,
    });
  };

  const validation = () => {
    let error = false;
    if (pageData.email !== emailToCheck) {
      error = true;
    }
    if (needChange) {
      if (pageData.newEmail === "") {
        error = true;
      }
    }
    return error;
  };
  const onClose = () => {
    if (!loader) {
      handleCancel();
    }
  };
  const getMemebersScope = () => {
    const membersScope: IOption[] = [];
    members
      .filter((_member) => _member.id !== userID && _member.role === "admin")
      .forEach((_fm) => {
        membersScope.push({ value: _fm.id, label: _fm.email });
      });

    return membersScope;
  };

  const checkBeforeDelete = () => {
    let email = "";
    if (pageData.newEmail !== "") {
      email =
        members.find((_member) => _member.id === pageData.newEmail)?.email ||
        "";
    }
    handleDelete(email);
  };
  return (
    <Modal
      title={t(dictionary.confirmDelete)}
      labelClose={t(dictionary.cancel)}
      handleClose={onClose}
      handleConfirm={checkBeforeDelete}
      labelConfirm={t(dictionary.closeAccount)}
      submitDisabled={validation()}
      submitLoader={loader}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      <Aligment gap={20}>
        <Text>
          {isSelf
            ? t(dictionary.doYouWantDeleteAccount)
            : t(dictionary.doYouWantDeleteUser)}
        </Text>
        <Text>
          {isSelf
            ? t(dictionary.confirmAccountDelete)
            : t(dictionary.confirmUserAccountDelete)}
        </Text>
        <IntputWrapperBig>
          <Input
            label={t(dictionary.enterEmailAddress)}
            type="text"
            labelPosition="top"
            value={pageData.email}
            name="login"
            handleChange={(name: string, value: ReactText) =>
              setEmailValue("email", value as string)
            }
          />
        </IntputWrapperBig>
        {needChange && (
          <>
            <Text>{t(dictionary.orgMailNeedChange)}</Text>
            <IntputWrapperBig>
              <Dropdown
                zIndex={1000}
                options={[...getMemebersScope()]}
                value={pageData.newEmail}
                handleSelect={(name: string, value: ReactText) =>
                  setEmailValue(name, value as string)
                }
                name={"newEmail"}
              />
            </IntputWrapperBig>
          </>
        )}
      </Aligment>
    </Modal>
  );
};
